module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Revoke User Access","introduction":["Are you sure you want to revoke access from the App User {displayName}?","Existing Submissions from this user will remain, but anybody relying on this user will have to create a new one to continue downloading Forms or uploading Submissions.","This action cannot be undone."]}}')
  delete Component.options._Ctor
}
